import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  TabContent,
  TabPane,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  CustomInput,
} from 'reactstrap';
import {
  ContAffiliation,
  H5Styled,
  ContFilterYear,
} from '../../../styled-components';
import Summary from './Summary';
import TotalRevenuesRow from './TotalTrRevenue';
import TotalEnergyRevenuesRow from './TotalTrEnergyRevenue';
import TotalInsuranceRevenuesRow from './TotalTrInsuranceRevenue';
import RoyaltyTable from './RoyaltyTable';
import InvoiceBonusTable from './InvoiceBonusTable';
import { useAuth } from '../../../commons/Auth';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import InsurancesRoyaltyTable from './InsurancesRoyaltyTable';
import EnergyRoyaltyTable from './EnergyRoyaltyTable';
import { USER_ADMIN_TYPES } from '../../../App';
import RoyaltyTableBackoffice from './RoyaltyTableBackoffice';
import InsurancesRoyaltyTableBackoffice from './InsurancesRoyaltyTableBackoffice';
import EnergyRoyaltyTableBackoffice from './EnergyRoyaltyTableBackoffice';

const NetworkFinancialReportsPresentational = ({
  data = {},
  onBonusDelete,
  onBonusUpdate,
  query,
  onFilter,
  profileType,
  addPaymentDate,
}) => {
  const [{ newIsAdmin, newUserType = '' } = {}] = useAuth();
  const [t] = useTranslation('CONTACTS');
  const { categories = {}, rowTotals = {}, rowCounts = {}, totals = {} } = data;

  const { bonuses = {} } = categories;

  const {
    rowRevenuesTotals = {},
    rowRevenuesInsuranceTotals = {},
    rowRevenuesEnergyTotals = {},
  } = rowTotals;

  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <ContFilterYear>
            <Row>
              <Col xs="6">
                <Label>{t('TITLE_FILTER_YEAR')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="selectYear"
                    name="year"
                    value={query && query.year}
                    onChange={({ target: { value: year } }) =>
                      onFilter({ year })
                    }
                  >
                    {generateYearOptions()}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>

          {rowCounts.variableRevenues > 0 ? (
            <ContAffiliation>
              <Row>
                <Col xs="6">
                  <H5Styled>{t('ROYALTY:TITLE')}</H5Styled>
                </Col>
                <Col xs="6" className="text-right" />
              </Row>
              <br />
              <br />
              {(newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
                <RoyaltyTable
                  data={[]}
                  bottomRow={
                    <TotalRevenuesRow
                      totals={rowRevenuesTotals}
                      route={`variable-revenues-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                  showEmptyTableMessage={false}
                  truncateTable={true}
                />
              )) || (
                <RoyaltyTableBackoffice
                  data={[]}
                  bottomRow={
                    <TotalRevenuesRow
                      totals={rowRevenuesTotals}
                      route={`variable-revenues-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                  showEmptyTableMessage={false}
                  truncateTable={true}
                />
              )}
            </ContAffiliation>
          ) : (
            <></>
          )}

          {totals.variableRevenuesInsurance &&
          totals.variableRevenuesInsurance > 0 ? (
            <ContAffiliation>
              <Row>
                <Col xs="6">
                  <H5Styled>{t('INSURANCES:ROYALTIES_TITLE')}</H5Styled>
                </Col>
                <Col xs="6" className="text-right" />
              </Row>
              <br />
              <br />
              {(newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
                <InsurancesRoyaltyTable
                  data={[]}
                  truncateTable={true}
                  showEmptyTableMessage={false}
                  bottomRow={
                    <TotalInsuranceRevenuesRow
                      totals={rowRevenuesInsuranceTotals}
                      route={`variable-revenues-insurances-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                />
              )) || (
                <InsurancesRoyaltyTableBackoffice
                  data={[]}
                  truncateTable={true}
                  showEmptyTableMessage={false}
                  bottomRow={
                    <TotalInsuranceRevenuesRow
                      totals={rowRevenuesInsuranceTotals}
                      route={`variable-revenues-insurances-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                />
              )}
            </ContAffiliation>
          ) : (
            <></>
          )}

          {totals.variableRevenuesEnergy &&
          totals.variableRevenuesEnergy > 0 ? (
            <ContAffiliation>
              <Row>
                <Col xs="6">
                  <H5Styled>{t('ENERGY:ROYALTIES_TITLE')}</H5Styled>
                </Col>
                <Col xs="6" className="text-right" />
              </Row>
              <br />
              <br />
              {(newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
                <EnergyRoyaltyTable
                  data={[]}
                  truncateTable={true}
                  onFilter={() => {}}
                  showEmptyTableMessage={false}
                  bottomRow={
                    <TotalEnergyRevenuesRow
                      totals={rowRevenuesEnergyTotals}
                      route={`variable-revenues-energy-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                />
              )) || (
                <EnergyRoyaltyTableBackoffice
                  data={[]}
                  truncateTable={true}
                  onFilter={() => {}}
                  showEmptyTableMessage={false}
                  bottomRow={
                    <TotalEnergyRevenuesRow
                      totals={rowRevenuesEnergyTotals}
                      route={`variable-revenues-energy-network${
                        query.year ? '?year=' + query.year : ''
                      }`}
                      activeRoute={true}
                      truncateTotals={true}
                    />
                  }
                />
              )}
            </ContAffiliation>
          ) : (
            <></>
          )}

          <ContAffiliation>
            <Row>
              <Col xs="6">
                <H5Styled>{t('LABEL_INVOICE_BONUS')}</H5Styled>
              </Col>
            </Row>
            <br />
            <InvoiceBonusTable
              data={bonuses.data || []}
              handleDeleteBonus={onBonusDelete}
              handleUpdateBonus={onBonusUpdate}
              newIsAdmin={newIsAdmin}
              onFilter={() => {}}
              addPaymentDate={addPaymentDate}
            />
          </ContAffiliation>

          <ContAffiliation>
            <H5Styled style={{ marginBottom: '5px' }}>
              {t('COMMON:SUMMARY')}
            </H5Styled>
            <Summary totals={totals} profileType={profileType} />
          </ContAffiliation>
        </TabPane>
      </TabContent>
    </Form>
  );
};

export default NetworkFinancialReportsPresentational;
